import CustomIcon from '../../assets/icons/products/custom.webp';
import ShoesIcon from '../../assets/icons/products/horseshoe.webp';
import NailsIcon from '../../assets/icons/products/nail.webp';
import OtherIcon from '../../assets/icons/products/other.webp';
import RaspsIcon from '../../assets/icons/products/rasp.webp';
import ToolsIcon from '../../assets/icons/products/tool.webp';
import { ProductType } from '../../types/Products';

export const ProductImages = {
    [ProductType.shoes]: ShoesIcon,
    [ProductType.nails]: NailsIcon,
    [ProductType.rasps]: RaspsIcon,
    [ProductType.tools]: ToolsIcon,
    [ProductType.other]: OtherIcon,
    [ProductType.custom]: CustomIcon,
};
